import EvaluationParametersPeriod, { IEvaluationParametersPeriodDto } from './EvaluationParametersPeriod';

export interface IGetEvaluationParametersPeriodsDto {
    entities: IEvaluationParametersPeriodDto[]
}

export default class EvaluationParametersPeriods {
    entities: EvaluationParametersPeriod[]

    constructor(dto: IGetEvaluationParametersPeriodsDto) {
        this.entities = dto.entities?.map(e => new EvaluationParametersPeriod(e)) || []
    }
}
